import { makeAutoObservable } from 'mobx';

export default class UserStore {
  constructor() {
    this._isAuth = false;
    this._user = {};
    makeAutoObservable(this);
  }

  setIsAuth(bool) {
    console.log('🔑 setIsAuth:', bool); // ← ЛОГ
    this._isAuth = bool;
  }

  setUser(user) {
    console.log('👤 setUser:', user); // ← ЛОГ
    console.log('👤 Роль пользователя:', user?.role); // ← ЛОГ
    this._user = user;
  }

  get isAuth() {
    return this._isAuth;
  }

  get user() {
    return this._user;
  }

  get isAdmin() {
    console.log('🔍 Проверка isAdmin, роль:', this._user?.role); // ← ЛОГ
    return this._user?.role === 'ADMIN';
  }
}